import React from 'react';
import { Link } from 'react-router-dom';
import './Tv&GypsumwallUnits.css';
import QuoteForm from '../../components/QuoteForm';
import SEO from '../../components/SEO';

// Import TV and Gypsum images
import tvImage1 from '../../assets/Tv/Tv1.webp';
import tvImage2 from '../../assets/Tv/Tv2.webp';
import tvImage3 from '../../assets/Tv/Tv3.webp';
import gypsumImage1 from '../../assets/Gypsum Wall Unit/IMG-20260417-WA0021.webp';
import gypsumImage2 from '../../assets/Gypsum Wall Unit/IMG-20260417-WA0022.webp';

import puStoneImg1 from '../../assets/TV wall unit with Pu stone decoration/WhatsApp Image 2026-05-10 at 18.25.28 (1).jpeg';
import puStoneImg2 from '../../assets/TV wall unit with Pu stone decoration/WhatsApp Image 2026-05-10 at 18.25.28.jpeg';
import puStoneImg3 from '../../assets/TV wall unit with Pu stone decoration/WhatsApp Image 2026-05-10 at 18.25.29.jpeg';
import crystalCharcoalImg1 from '../../assets/TV wall unit with crystal charcoal board decoration/WhatsApp Image 2026-05-10 at 18.26.22 (1).jpeg';
import crystalCharcoalImg2 from '../../assets/TV wall unit with crystal charcoal board decoration/WhatsApp Image 2026-05-10 at 18.26.22.jpeg';

const FOLDER_PU_STONE = 'TV wall unit with Pu stone decoration';
const FOLDER_CRYSTAL_CHARCOAL = 'TV wall unit with crystal charcoal board decoration';

const TvGypsumWallUnitsPage = () => {

  const services = [
    {
      title: 'TV Wall Units with Fluted Panels & Marble Sheets',
      description: 'Floating TV units with fluted panels, built-in entertainment centers with marble sheet finishes, and minimalist TV panels designed to maximize space and style.',
      icon: '📺'
    },
    {
      title: 'Gypsum Feature Walls',
      description: 'Decorative gypsum wall panels, TV background gypsum designs, and false wall installations with premium finishes.',
      icon: '🎨'
    },
    {
      title: 'LED TV Wall Designs',
      description: 'LED strip lighting integration, backlit TV panels with fluted accents, and ambient lighting setups for modern entertainment walls.',
      icon: '💡'
    },
    {
      title: 'Storage & Display Integration',
      description: 'Shelving units with marble sheet accents, hidden storage cabinets, and display niches that combine functionality with contemporary aesthetics.',
      icon: '🗄️'
    }
  ];

  const processSteps = [
    {
      step: '1',
      title: 'Consultation & Site Visit',
      description: 'We assess your space, understand your vision, and discuss design preferences for your TV wall unit.'
    },
    {
      step: '2',
      title: '3D Design & Visualization',
      description: 'Our designers create detailed 3D visuals so you can see the final TV wall design before installation.'
    },
    {
      step: '3',
      title: 'Material Selection',
      description: 'Choose from premium gypsum boards, wood finishes, LED lighting options, and hardware accessories.'
    },
    {
      step: '4',
      title: 'Fabrication & Installation',
      description: 'Expert craftsmen fabricate and install your custom TV wall unit with precision and attention to detail.'
    },
    {
      step: '5',
      title: 'Final Finishing & Handover',
      description: 'We complete all finishing touches, test lighting systems, and ensure everything meets our quality standards.'
    }
  ];

  const designStyles = [
    'Modern minimalist TV walls',
    'Luxury gypsum TV walls with lighting',
    'Wooden + gypsum combination walls',
    'Floating TV wall units',
    'Full media walls with storage',
    'Contemporary entertainment centers'
  ];

  const tvProjects = [
    { title: 'TV Wall Unit with Fluted Panels & Marble Sheets', category: 'Modern TV Wall', image: tvImage1 },
    { title: 'LED TV Wall with Fluted Accents', category: 'Entertainment Wall', image: tvImage2 },
    { title: 'Luxury TV Unit with Marble Finish', category: 'Custom TV Wall', image: tvImage3 }
  ];

  const gypsumProjects = [
    { title: 'Contemporary Gypsum TV Wall', category: 'Gypsum Design', image: gypsumImage1 },
    { title: 'Gypsum Feature Wall with Storage', category: 'TV Background', image: gypsumImage2 }
  ];

  const puStoneProjects = [
    { title: `${FOLDER_PU_STONE} — view 1`, image: puStoneImg1 },
    { title: `${FOLDER_PU_STONE} — view 2`, image: puStoneImg2 },
    { title: `${FOLDER_PU_STONE} — view 3`, image: puStoneImg3 }
  ];

  const crystalCharcoalProjects = [
    { title: `${FOLDER_CRYSTAL_CHARCOAL} — view 1`, image: crystalCharcoalImg1 },
    { title: `${FOLDER_CRYSTAL_CHARCOAL} — view 2`, image: crystalCharcoalImg2 }
  ];

  const faqs = [
    {
      question: 'How much does a TV wall unit cost in Kenya?',
      answer: 'The cost varies depending on design complexity, size, materials, and lighting features. We offer flexible packages for both budget and luxury TV wall units. Contact us for a free consultation and detailed quote tailored to your specific requirements.'
    },
    {
      question: 'What is the best gypsum design for a TV wall?',
      answer: 'The best design depends on your space, style preferences, and budget. Popular options include minimalist gypsum panels with LED lighting, textured gypsum walls, and combination designs with wood accents. Our designers will recommend the perfect solution during your consultation.'
    },
    {
      question: 'Can you install LED lighting in TV walls?',
      answer: 'Yes! We specialize in LED TV wall designs including strip lighting, backlit panels, and ambient lighting setups. LED lighting adds a modern touch and creates the perfect viewing atmosphere for your entertainment space.'
    },
    {
      question: 'How long does TV wall installation take?',
      answer: 'A standard TV wall unit installation typically takes 3-7 days, while complex media walls with extensive storage and lighting may take 1-2 weeks. The timeline depends on the design complexity and customization level.'
    },
    {
      question: 'Are gypsum walls durable?',
      answer: 'Yes, gypsum walls are highly durable when properly installed. They are fire-resistant, moisture-resistant, and can last for many years with minimal maintenance. We use high-quality gypsum boards and professional installation techniques to ensure longevity.'
    }
  ];

  const whyChooseUs = [
    'Modern and luxury TV wall designs',
    'High-quality gypsum and premium finishes',
    'Space-saving customized solutions',
    'Fully tailored to your room dimensions',
    'Professional installation across Kenya',
    'Affordable pricing with transparent quotes'
  ];

  const testimonials = [
    {
      name: 'Peter M.',
      location: 'Nairobi',
      text: 'The TV wall unit transformed our living room completely. The LED lighting and gypsum design are stunning. Professional team from start to finish!',
      rating: 5
    },
    {
      name: 'Catherine W.',
      location: 'Mombasa',
      text: 'We love our new media wall! The storage solutions are perfect, and the 3D design helped us visualize everything before installation. Highly recommend!',
      rating: 5
    },
    {
      name: 'John K.',
      location: 'Kisumu',
      text: 'Excellent craftsmanship and attention to detail. The floating TV unit looks amazing and the team completed the project on time. Very satisfied!',
      rating: 5
    }
  ];

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "TV & Gypsum Wall Units",
    "provider": {
      "@type": "LocalBusiness",
      "name": "Techie Interiors",
      "telephone": "+254748600208",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Nairobi",
        "addressCountry": "KE"
      }
    },
    "areaServed": "Kenya",
    "description": "Custom TV wall units and gypsum feature wall installations in Nairobi Kenya. Modern entertainment centers with fluted panels, marble sheets, and LED integration."
  };

  return (
    <div className="tv-gypsum-page">
      {/* SEO Component */}
      <SEO
        title="TV Wall Units & Gypsum Feature Walls Design Nairobi | Techie Interiors"
        description="Custom TV wall units and gypsum feature walls in Nairobi Kenya. Modern entertainment centers with fluted panels, marble sheets, LED lighting, and storage integration."
        image={tvImage1}
        url="https://techieinteriors.co.ke/tv-gypsum-wall"
        structuredData={structuredData}
      />
      {/* 1. HERO SECTION */}
      <section className="tv-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Modern TV Wall Units & Gypsum Wall Designs in Kenya</h1>
          <p>Custom TV units, gypsum feature walls, and modern media walls designed to elevate your living room with style, storage, and lighting.</p>
          <div className="hero-buttons">
            <a href="#contact-form" className="btn btn-primary">Get a Free Quote</a>
            <a href="#portfolio" className="btn btn-secondary">View Our Designs</a>
          </div>
        </div>
      </section>

      {/* 2. INTRODUCTION SECTION */}
      <section className="tv-intro">
        <div className="container">
          <div className="intro-content">
            <h2 className="section-title-left">Transform Your Living Space with Custom TV & Gypsum Wall Units</h2>
            <p>
              We design and install premium <strong>TV wall units</strong> and <strong>gypsum wall designs in Kenya</strong>, combining functionality with aesthetics. Whether you want a modern floating TV unit, a gypsum feature wall with LED lighting, or a full media wall with storage, Techie Interiors delivers tailored solutions that match your space and lifestyle.
            </p>
            <p>
              Our <strong>custom TV unit</strong> designs are crafted to enhance your living room while providing practical storage solutions. From minimalist designs to luxury entertainment centers, we bring your vision to life with expert <strong>interior design in Kenya</strong>.
            </p>
          </div>
        </div>
      </section>

      {/* 3. SERVICES BREAKDOWN */}
      <section className="tv-services">
        <div className="container">
          <h2 className="section-title">Our TV & Gypsum Wall Unit Services</h2>
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card">
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <ul className="service-list">
                  {service.description.split(', ').map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 4. WHY CHOOSE US */}
      <section className="tv-why-choose">
        <div className="container">
          <h2 className="section-title">Why Choose Our Gypsum TV Wall Designs?</h2>
          <div className="why-choose-grid">
            {whyChooseUs.map((item, index) => (
              <div key={index} className="why-choose-item">
                <div className="check-icon">✓</div>
                <p>{item}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 5. DESIGN STYLES SECTION */}
      <section className="tv-design-styles">
        <div className="container">
          <h2 className="section-title">Popular TV & Gypsum Wall Design Styles</h2>
          <div className="styles-grid">
            {designStyles.map((style, index) => (
              <div key={index} className="style-item">
                <div className="style-icon">🎨</div>
                <h3>{style}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 6. PORTFOLIO / GALLERY */}
      <section className="tv-portfolio" id="portfolio">
        <div className="container">
          <h2 className="section-title">Our Recent TV Wall & Gypsum Projects</h2>
          <p className="portfolio-intro">Browse our collection of modern TV wall designs and gypsum installations across Kenya.</p>
          
          {/* TV Wall Units Section */}
          <div className="portfolio-category">
            <h3 className="category-title">TV Wall Units with Fluted Panels & Marble Sheets</h3>
            <div className="portfolio-grid">
              {tvProjects.map((item, index) => (
                <div key={index} className="portfolio-card">
                  <img src={item.image} alt={item.title} className="portfolio-image" loading="lazy" decoding="async" />
                </div>
              ))}
            </div>
          </div>

          <div className="portfolio-category">
            <h3 className="category-title">{FOLDER_PU_STONE}</h3>
            <div className="portfolio-grid">
              {puStoneProjects.map((item, index) => (
                <div key={`pu-stone-${index}`} className="portfolio-card">
                  <img src={item.image} alt={item.title} className="portfolio-image" loading="lazy" decoding="async" />
                </div>
              ))}
            </div>
          </div>

          <div className="portfolio-category">
            <h3 className="category-title">{FOLDER_CRYSTAL_CHARCOAL}</h3>
            <div className="portfolio-grid">
              {crystalCharcoalProjects.map((item, index) => (
                <div key={`crystal-charcoal-${index}`} className="portfolio-card">
                  <img src={item.image} alt={item.title} className="portfolio-image" loading="lazy" decoding="async" />
                </div>
              ))}
            </div>
          </div>

          {/* Gypsum Wall Units Section */}
          <div className="portfolio-category">
            <h3 className="category-title">Gypsum Wall Units</h3>
            <div className="portfolio-grid">
              {gypsumProjects.map((item, index) => (
                <div key={index} className="portfolio-card">
                  <img src={item.image} alt={item.title} className="portfolio-image" loading="lazy" decoding="async" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 7. PROCESS SECTION */}
      <section className="tv-process">
        <div className="container">
          <h2 className="section-title">Our TV Wall Design & Installation Process</h2>
          <div className="process-steps">
            {processSteps.map((step, index) => (
              <div key={index} className="process-step">
                <div className="step-number">{step.step}</div>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 8. PRICING / ESTIMATE SECTION */}
      <section className="tv-pricing">
        <div className="container">
          <div className="pricing-content">
            <h2 className="section-title-left">Affordable TV & Gypsum Wall Units in Kenya</h2>
            <p>
              Pricing depends on design complexity, size, materials, and lighting features. We offer flexible packages for both budget and luxury TV wall units.
            </p>
            <ul className="pricing-features">
              <li>✓ Free consultation with  a design expert</li>
              <li>✓ Custom 3D design visualization</li>
              <li>✓ Premium materials and finishes</li>
              <li>✓ Professional installation included</li>
              <li>✓ Site visit and measurement</li>
              <li>✓ Flexible payment options</li>
            </ul>
            <a href="#contact-form" className="btn btn-primary">👉 Request a Free Quote Today</a>
          </div>
        </div>
      </section>

      {/* 9. FAQ SECTION */}
      <section className="tv-faq">
        <div className="container">
          <h2 className="section-title">Frequently Asked Questions About TV & Gypsum Wall Units</h2>
          <div className="faq-list">
            {faqs.map((faq, index) => (
              <div key={index} className="faq-item">
                <h3>{faq.question}</h3>
                <p>{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 11. CONTACT FORM */}
      <section className="tv-form-section" id="contact-form">
        <div className="container">
          <h2 className="section-title">Request a TV & Gypsum Wall Unit Quote</h2>
          <div className="form-wrapper">
            <div className="contact-info">
              <h3>Get In Touch</h3>
              <p>Have questions about our TV wall units and gypsum wall designs? We're here to help transform your living space.</p>
              <div className="info-item">
                <strong>Phone:</strong>
                <span>+254748600208</span>
              </div>
              <div className="info-item">
                <strong>Email:</strong>
                <span>info@techieinteriors.co.ke</span>
              </div>
              <div className="info-item">
                <strong>Location:</strong>
                <span>Nairobi, Kenya</span>
              </div>
              <div className="trust-line">
                <strong>We respond instantly.</strong>
              </div>
            </div>
            <QuoteForm serviceName="TV & Gypsum Wall Units" />
          </div>
        </div>
      </section>

      {/* 12. TESTIMONIALS */}
      <section className="tv-trust">
        <div className="container">
          <h2 className="section-title">Trusted Across Kenya</h2>
          <p className="trust-subtitle">We've delivered stunning TV wall units and gypsum designs to homes across Kenya</p>
          <div className="testimonials-grid">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-card">
                <div className="rating">{'⭐'.repeat(testimonial.rating)}</div>
                <p className="testimonial-text">"{testimonial.text}"</p>
                <div className="testimonial-author">
                  <strong>{testimonial.name}</strong>
                  <span>{testimonial.location}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 13. SEO FOOTER CONTENT */}
      <section className="tv-seo-footer">
        <div className="container">
          <p>
            We specialize in custom TV wall units, gypsum wall designs, and modern media walls across Kenya. Our services include <strong>TV wall design in Kenya</strong>, <strong>gypsum TV wall in Nairobi</strong>, LED TV wall units, entertainment wall designs, custom TV cabinets, and gypsum feature wall installations. Whether you need a minimalist floating TV unit or a luxury entertainment center with storage, our expert team delivers premium quality and professional installation throughout Kenya.
          </p>
          <p>
            Related pages: <Link to="/gypsum-ceiling">gypsum ceiling services</Link>,{' '}
            <Link to="/kitchen-wardrobe-fitting">kitchen and wardrobe fitting</Link>,{' '}
            <Link to="/office-fitouts-kenya">office fit-outs in Kenya</Link>, and{' '}
            <Link to="/project">project gallery</Link>.
          </p>
        </div>
      </section>
    </div>
  );
};

export default TvGypsumWallUnitsPage;